
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Balance from "../../components/Balance/Balance";

export const BalancePage = () => {

  return (
    <div >
      <Header/>
      <Balance/>
      <Footer/>
    </div>

  );
};


